import { useContext } from "react";
import { motion } from "framer-motion";
import { context } from "../../context/context";
// import LastLoans from "./tinyComponents/LastLoan";

const Dashboard = () => {
  const { user } = useContext(context);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 0.5,
        // ease: [0, 0.71, 0.2, 1.01]
      }}
      className="w-11/12 mx-auto"
    >
      <div className="flex flex-wrap justify-center items-center gap-4 w-full my-6 shadow-sm">
        <div className="flex justify-center items-center py-3 text-gray-800 dark:text-white text-lg rounded-lg w-full bg-white dark:bg-[#060d26]">
          <p>{user?.name || "کاربر"} عزیز، به پنل خود خوش آمدید.</p>
        </div>
      </div>
      {/* <LastLoans /> */}
    </motion.div>
  );
};

export default Dashboard;
